import IconChevronDownLarge from '@picsart/icons/IconChevronDownLarge';
import classNames from 'classnames';

import usePopupState from '../../../../hooks//usePopupState';

import useStyles from './styles';
import { ISkinDropdown } from './types';

function SkinToneDropDown({ values, selectedValue, setSelectedValue }: ISkinDropdown) {
  const classes = useStyles();
  const [isOpen, toggle] = usePopupState();

  const handleChangeSkinTone = (index: number) => {
    setSelectedValue(index);
  };

  return (
    <div className={classes.root}>
      <button className={classes.button} onClick={toggle}>
        {values[selectedValue]} <span className={classes.buttonText}>Skin tone</span>
        <IconChevronDownLarge className={classes.icon} />
      </button>
      {isOpen && (
        <div className={classes.container}>
          <ul className={classes.items}>
            {values.map((value, index) => (
              <li
                key={index}
                className={classNames(
                  classes.item,
                  index === selectedValue ? classes.itemSelected : null,
                )}
                onClick={() => handleChangeSkinTone(index)}
              >
                {' '}
                {value}
              </li>
            ))}
          </ul>
          <span className={classes.containerText}>Choose your skin tone</span>
        </div>
      )}
    </div>
  );
}
export default SkinToneDropDown;
